import { Button, ButtonGroup, Stack, SvgIcon, Tooltip, buttonClasses } from '@mui/material';
import { useState } from 'react';

import { Span, isDefined } from 'common';

import { ReactComponent as FlowAiMark } from '../../../scenes/AgenticChat/Assets/flow-ai.svg';
import { AgenticChatRecentChatsMenu } from '../../AgenticChat/RecentChatsMenu';
import { useAgenticChatContext } from '../../AgenticChat/context';
import { useSideNavigationAnimation } from '../Animation';
import { SIDEBAR_NAVIGATION_SX_MARGIN_X } from '../constants';
import { SideNavigationState, useSideNavigationModeContext } from '../context';

export function SidebarNavigationAgenticChatLink() {
  const { agenticChatVisibility, toggleAgenticChatVisibility } = useAgenticChatContext();
  const isVisible = agenticChatVisibility === 'Open';
  const { sideNavigationOpacityAnimation } = useSideNavigationAnimation();
  const { sideNavigationState, setIsSearchInputFocused } = useSideNavigationModeContext();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  return (
    <Stack marginX={SIDEBAR_NAVIGATION_SX_MARGIN_X}>
      <ButtonGroup
        variant="contained"
        color="primary"
        size="small"
        disableElevation
        sx={{
          [`& .${buttonClasses.root}`]: {
            fontSize: 'body2.fontSize',
            backgroundColor: isVisible ? 'agenticChat.main' : 'agenticChat.dark',
            '&:hover': {
              backgroundColor: isVisible ? 'agenticChat.light' : 'agenticChat.main',
            },
          },
        }}
      >
        <Tooltip
          title={sideNavigationState === SideNavigationState.Collapsed ? 'Flow AI' : ''}
          placement="right"
        >
          <Button
            onClick={() => toggleAgenticChatVisibility()}
            aria-label="Flow AI"
            aria-expanded={isVisible}
            aria-controls="global-flow-ai"
            sx={{
              flex: 1,
              justifyContent: 'flex-start',
              gap: 1,
              fontWeight: 'fontWeightBold',
              whiteSpace: 'nowrap',
            }}
            tabIndex={sideNavigationState === SideNavigationState.Collapsed ? -1 : 0}
          >
            <SvgIcon component={FlowAiMark} inheritViewBox sx={{ fontSize: 16, flexShrink: 0 }} />
            <Span sx={sideNavigationOpacityAnimation}>Flow AI</Span>
          </Button>
        </Tooltip>
        {sideNavigationState !== SideNavigationState.Collapsed && (
          <Button
            aria-label="Recent chats"
            aria-haspopup="menu"
            aria-expanded={isDefined(anchor)}
            aria-controls={isDefined(anchor) ? 'sidebar-recent-chats' : undefined}
            onClick={(event) => {
              setAnchor(event.currentTarget);
              setIsSearchInputFocused(true);
            }}
            sx={{ flexShrink: 0 }}
          >
            Recents
          </Button>
        )}
      </ButtonGroup>
      <AgenticChatRecentChatsMenu
        id="sidebar-recent-chats"
        anchorEl={anchor}
        onClose={() => {
          setAnchor(null);
          setIsSearchInputFocused(false);
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      />
    </Stack>
  );
}
